import { render } from "./airqualitynpRGBProducts.vue?vue&type=template&id=6e767e78"
import script from "./airqualitynpRGBProducts.vue?vue&type=script&lang=js"
export * from "./airqualitynpRGBProducts.vue?vue&type=script&lang=js"

import "./airqualitynpRGBProducts.vue?vue&type=style&index=0&id=6e767e78&lang=scss"

import exportComponent from "/home/manohar/Bhutan_gitlab/tethysapp-airqualitybt/tethysapp/airqualitybt/vairqualitybt/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__